module.exports = __webpack_public_path__ + "img/mobile-neck-4_18x196.b33ea7c7.png";